import {
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useCallback, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../../components/CustomPagination";
import styles from "./style";
import color from "../../../../../constants/color";
import { formatDate } from "../../../../../utils/DateFormat";

const AllTransactionList = ({
  data = [],
  page,
  setPage,
  total,
  vendors,
  customers,
}) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  const getId = (row, idx) => row._id ?? row.id ?? idx;

  const handleToggle = useCallback(
    (id) => (e) => {
      e.stopPropagation();
      setSelected((prev) =>
        prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
      );
    },
    []
  );

  const handleToggleAll = (e) => {
    e.stopPropagation();
    const pageIds = data.map(getId);
    const allOnPage = pageIds.every((id) => selected.includes(id));

    setSelected((prev) =>
      allOnPage
        ? prev.filter((id) => !pageIds.includes(id))
        : [...prev, ...pageIds.filter((id) => !prev.includes(id))]
    );
  };

  const allChecked =
    data.length > 0 && data.every((r, i) => selected.includes(getId(r, i)));
  const indeterminate = selected.length > 0 && !allChecked;

  const vendorMap = useMemo(() => {
    const map = {};
    vendors.forEach((v) => {
      map[v._id] = v.name;
    });
    return map;
  }, [vendors]);

  const customerMap = useMemo(() => {
    const map = {};
    customers.forEach((c) => {
      map[c._id] = c.name;
    });
    return map;
  }, [customers]);

  return (
    <Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {/* <TableCell sx={styles.TableHead}>
                <Checkbox
                  sx={{ p: 0, m: 0 }}
                  checked={allChecked}
                  indeterminate={indeterminate}
                  onClick={handleToggleAll}
                />
              </TableCell> */}
              <TableCell sx={styles.TableHead}>Date</TableCell>
              <TableCell sx={styles.TableHead}>Description</TableCell>
              <TableCell sx={styles.TableHead}>Status</TableCell>
              <TableCell sx={styles.TableHead}>Type</TableCell>
              <TableCell sx={styles.TableHead}>Method</TableCell>
              <TableCell sx={styles.TableHead} align="right">
                Deposits
              </TableCell>
              <TableCell sx={styles.TableHead} align="right">
                Withdrawals
              </TableCell>
              <TableCell sx={styles.TableHead} align="right">
                Running Balance
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, idx) => {
                const rowId = getId(item, idx);
                const vendorName = item.vendor
                  ? vendorMap[item.vendor._id || item.vendor] ||
                    item.vendor.name ||
                    item.vendor
                  : "";
                const customerName = item.customer
                  ? customerMap[item.customer._id || item.customer] ||
                    item.customer.name ||
                    item.customer
                  : "";
                return (
                  <TableRow
                    key={rowId}
                    hover
                    sx={{ cursor: "pointer" }}
                    // onClick={() => navigate(`/transactions/${rowId}`)}
                  >
                    {/* <TableCell sx={styles.tableData}>
                      <Checkbox
                        sx={{ p: 0, m: 0 }}
                        checked={selected.includes(rowId)}
                        onClick={handleToggle(rowId)}
                      />
                    </TableCell> */}
                    <TableCell sx={styles.tableData}>
                      {item?.date
                        ? formatDate(item.date)
                        : ""}
                    </TableCell>
                    <TableCell
                      sx={{
                        ...styles.tableData,
                        maxWidth: 200,
                        minWidth: 120,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={item.description}
                    >
                      {item.description}
                    </TableCell>
                    <TableCell
                      sx={{ ...styles.tableData, color: color.lightText }}
                    >
                      {item.status}
                    </TableCell>
                    <TableCell sx={styles.tableData}>
                      {
                        <Box>
                          <Typography 
                            sx={{
                              fontWeight: 500,
                              fontSize: "13px",
                              color: color.text,
                            }}
                          >
                            {item.labelName || (item.customer ? "Customer Payment" : "Vendor Payment")}
                          </Typography>
                          {
                            item.customer && (
                              <Typography
                                sx={{ fontSize: "12px", color: color.lightText }}
                              >
                                {item.customer && `Customer: ${customerName}`}
                              </Typography>
                            )
                          }
                          {
                            item.vendor && (
                              <Typography
                                sx={{ fontSize: "12px", color: color.lightText }}
                              >
                                {item.vendor && `Vendor: ${vendorName}`}
                              </Typography>
                            )
                          }
                        </Box>
                      }
                    </TableCell>
                    <TableCell sx={styles.tableData}>{item.paidVia || "-"}</TableCell>
                    <TableCell sx={styles.tableData} align="right">
                      {item.deposit ? `$${item.deposit}` : ""}
                    </TableCell>
                    <TableCell sx={styles.tableData} align="right">
                      {item.withdrawal ? `$${item.withdrawal}` : ""}
                    </TableCell>
                    <TableCell sx={styles.tableData} align="right">
                      ${item.runningBalance}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>

        <CustomPagination
          pageCount={total}
          totalItems={total}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default AllTransactionList;
